var React = require('react');

function BillInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"bill.inline"),React.createElement("g",{"id":"b65802e4-78cb-40f8-9457-70f6cd31cb75","data-name":"Layer 2","key":1},React.createElement("g",{"id":"e36eaf15-caf8-49ba-9e00-928df48e9244","data-name":"Layer 1"},React.createElement("g",{"id":"ab3a0c8d-201d-4b9a-893e-fb14aaa15d3b","data-name":"bill.inline"},[React.createElement("path",{"className":"use-fill-only","d":"M38.88,0H0V21H38.88ZM37.26,19.33H1.62V1.62H37.26Z","key":0}),React.createElement("path",{"d":"M24.3,10.47c0,3.48-2.18,6.3-4.86,6.3s-4.86-2.82-4.86-6.3,2.18-6.29,4.86-6.29S24.3,7,24.3,10.47ZM0,14.35A6.6,6.6,0,0,1,6.6,21m25.68,0a6.6,6.6,0,0,1,6.6-6.6m0-7.75A6.61,6.61,0,0,1,32.28,0M6.6,0A6.61,6.61,0,0,1,0,6.6","fill":"none","stroke":"#000","strokeMiterlimit":"10","strokeWidth":"1.62","key":1})])))]);
}

BillInline.defaultProps = {"viewBox":"0 0 38.88 20.95"};

module.exports = BillInline;

BillInline.default = BillInline;
